//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import DeliverablesV1 from '../Deliverables/DeliverablesV1';
import AssetList from './AssetList';
import AssetProgress from './AssetProgress';
import { selectJob } from '@/redux/selectors/jobSelectors';
import DeliverablesV2 from '../Deliverables/DeliverablesV2';
import { useAppSelector } from '@/redux/hooks';

const JobTabAssetStatus = () => {
  const jobData = useAppSelector(selectJob);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={6}>
        <Card elevation={0}>
          <CardHeader title="Requirements" disableTypography />
          <CardContent>
            <AssetProgress />
            <AssetList />
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} lg={6}>
        <Card elevation={0}>
          <CardHeader title="Deliverables" disableTypography />
          <CardContent>
            {jobData.schema_version === 'v2' ? <DeliverablesV2 /> : <DeliverablesV1 />}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default JobTabAssetStatus;
